import React, { useState } from 'react'
import styles from './modal-field.module.scss'
import { Controller, useFormContext } from 'react-hook-form'
import { BottomSheet, Button, Typography } from '@/ui-kit'
import { MyProfile } from '@/types/profile'
import { DropdownIndicator } from '@/assets/icons'
import clsx from 'clsx'
import { RadioCupertino } from '@/ui-kit/radio-cupertino'
import { useTranslation } from 'react-i18next'
import { ProfileEditSchemaType } from '@/schemes/profile-edit-schema'

interface Props {
    userData: MyProfile
    field: keyof ProfileEditSchemaType
    values: string[]
    defaultVal?: string
    handleUpdateUserData: (data: any, needToast?: boolean, onSuccess?: () => void) => Promise<void>
    collectEditEvent: (field: string) => void
}

export const ModalField: React.FC<Props> = ({
    userData,
    field,
    values,
    defaultVal,
    handleUpdateUserData,
    collectEditEvent,
}) => {
    const { t } = useTranslation()

    const methods = useFormContext<ProfileEditSchemaType>()

    const [isEditModalOpen, setIsEditModalOpen] = useState(false)

    const defaultValTranslation = values.find(option => option === defaultVal)

    return (
        <>
            <button
                type="button"
                id={field}
                className={styles.modalControl}
                onClick={async () => setIsEditModalOpen(true)}>
                <Typography fontFamily="SFProText" className={styles.modalControlText}>
                    {t(`${field}.title`)}
                </Typography>
                <div className={styles.modalControlTrailing}>
                    <Typography variant="span" typeColor="gray">
                        {
                            defaultValTranslation ? t(`${field}.${defaultValTranslation}`, { context: userData.gender }) : t('profile.not_specified')
                        }
                    </Typography>
                    <DropdownIndicator />
                </div>
            </button>

            <BottomSheet
                isOpen={isEditModalOpen}
                isDeskorTop={true}
                className={styles.bottomsheet}
                onClose={() => {
                    setIsEditModalOpen(false)
                    methods.resetField(field)
                }}>
                <Controller
                    control={methods.control}
                    name={field}
                    render={({ field: { onChange, value } }) => {
                        return (
                            <div className={styles.choiceEditModalContent}>
                                <div className={styles.choiceEditModalContentHeader}>
                                    <Typography
                                        variant={'h5'}
                                        fontWeight={'bold'}>
                                        {t(`${field}.title`)}
                                    </Typography>
                                </div>
                                <div className={styles.choiceEditModalContentMain}>
                                    <div className={styles.choiceEditModalContentMainInput}>
                                        <div className={styles.radiosList}>
                                            {
                                                values.map(option => {
                                                    return (
                                                        <div
                                                            className={
                                                                clsx(
                                                                    styles.radioBtn,
                                                                    value === option && styles.radioBtnActive
                                                                )
                                                            }>
                                                            <RadioCupertino
                                                                label={t(`${field}.${option}`, { context: userData.gender })}
                                                                value={option}
                                                                name={field}
                                                                checked={value === option}
                                                                onChange={onChange} />
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                    <div className={styles.choiceEditModalContentFooter}>
                                        <Button
                                            typeColor="orange"
                                            className={styles.choiceEditModalContentFooterBtn}
                                            disabled={value === defaultVal}
                                            onClick={() => {
                                                collectEditEvent('smoking')
                                                handleUpdateUserData(
                                                    {
                                                        ...userData,
                                                        [field]: value
                                                    },
                                                    true
                                                )
                                                setIsEditModalOpen(false)
                                            }}>
                                            {t('done')}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        )
                    }} />
            </BottomSheet>
        </>
    )
}
